import './Flag.styles.css';
import FlagImage from "../../assets/images/global/flags.png";

const FlagComponent = ({countryCode}) => {

    return <div className="react-tel-input">
        <div className={`flag ${countryCode.toLowerCase()}`} style={{backgroundImage: `url(${FlagImage})`}} />
    </div>

}

export default FlagComponent;